import React from "react";

import { twMerge } from "tailwind-merge";

type CustomCardProps = {
  children?: React.ReactNode;
  className?: string;
  additionalStyle?: any;
  forwardRef?: React.RefObject<HTMLDivElement>;
  noShadow?: boolean;
  id?: any;
};

const CustomCard = ({
  forwardRef,
  children,
  className,
  additionalStyle,
  noShadow,
  ...props
}: CustomCardProps) => {
  return (
    <div
      ref={forwardRef}
      className={twMerge(
        "bg-white",
        "rounded-[10px]",
        "transform-gpu",
        noShadow ? "" : "shadow-lg",
        "p-[30px]",
        "mb-[30px]",
        className
      )}
      style={additionalStyle}
      {...props}
    >
      {children}
    </div>
  );
};

export default CustomCard;
